// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-imageWrapper {
	cursor: -webkit-grab;
	cursor: grab;
	position: relative;
}

.FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-hoverOverlay {
	border-radius: 4px;
	display: none;
	height: 100%;
	left: 0;
	pointer-events: none;
	position: absolute;
	top: 0;
	width: 100%;
}

.FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-hoverOverlayNewButton {
	pointer-events: auto;
}

.FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-hoverOverlayUnpinButton {
	pointer-events: auto;
	position: absolute;
	right: 8px;
	top: 8px;
}

.FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-imageWrapper:hover .FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-hoverOverlay {
	-webkit-animation: FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-fadein 0.3s;
	        animation: FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-fadein 0.3s;
	background-color: rgba(0, 0, 0, 0.4);
	display: -ms-flexbox;
	display: flex;
}

.FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-pinnedImage {
	padding: 4px;
}

@-webkit-keyframes FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-fadein {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

@keyframes FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-fadein {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}
`, "",{"version":3,"sources":["webpack://./src/FashionInspiration/components/explorationPinnedImagesListItem/ExplorationPinnedImagesListItem.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAY;CAAZ,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,YAAY;CACZ,OAAO;CACP,oBAAoB;CACpB,kBAAkB;CAClB,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,UAAU;CACV,QAAQ;AACT;;AAEA;CACC,mIAAsB;SAAtB,2HAAsB;CACtB,oCAAkC;CAClC,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;AACD;;AARA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;AACD","sourcesContent":[".imageWrapper {\n\tcursor: grab;\n\tposition: relative;\n}\n\n.hoverOverlay {\n\tborder-radius: 4px;\n\tdisplay: none;\n\theight: 100%;\n\tleft: 0;\n\tpointer-events: none;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n}\n\n.hoverOverlayNewButton {\n\tpointer-events: auto;\n}\n\n.hoverOverlayUnpinButton {\n\tpointer-events: auto;\n\tposition: absolute;\n\tright: 8px;\n\ttop: 8px;\n}\n\n.imageWrapper:hover .hoverOverlay {\n\tanimation: fadein 0.3s;\n\tbackground-color: rgb(0 0 0 / 40%);\n\tdisplay: flex;\n}\n\n.pinnedImage {\n\tpadding: 4px;\n}\n\n@keyframes fadein {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageWrapper": `FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-imageWrapper`,
	"hoverOverlay": `FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-hoverOverlay`,
	"hoverOverlayNewButton": `FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-hoverOverlayNewButton`,
	"hoverOverlayUnpinButton": `FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-hoverOverlayUnpinButton`,
	"fadein": `FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-fadein`,
	"pinnedImage": `FashionInspiration-components-explorationPinnedImagesListItem-ExplorationPinnedImagesListItem-module-pinnedImage`
};
module.exports = ___CSS_LOADER_EXPORT___;
